import React from 'react'
import { Pagination } from 'react-bootstrap'
import ButterToast, { Cinnamon } from 'butter-toast'
import { useStateValue } from '../../state'
import { client } from '../../utils'
import { notebook as endpoints } from '../../api_urls'

const NotebookPagintaion = () => {
  let [currentState, dispatch] = useStateValue()

  const updatePageNum = async data => {
    try {
      let resp = await client.post(endpoints.filterHighlights(), data)
      dispatch({ type: 'updateHighlights', payload: resp.data.highlights })
      dispatch({ type: 'updatePageNum', payload: resp.data.page })
      dispatch({ type: 'updateHighlightCount', payload: resp.data.hlCount })
    } catch (err) {
      ButterToast.raise({
        content: (
          <Cinnamon.Crisp
            title="Error"
            content={err.response.data.error}
            scheme={Cinnamon.Crisp.SCHEME_RED}
            icon={<i className="far fa-thumbs-down fa-3x" />}
          />
        ),
        sticky: true,
      })
    }
  }

  return (
    <div>
      <Pagination
        prev={<span className="text-dark">{'<'}</span>}
        next={<span className="text-dark">{'>'}</span>}
        first={<span className="text-dark">{'<<'}</span>}
        last={<span className="text-dark">{'>>'}</span>}
        maxButtons={5}
        items={Math.ceil(currentState.hlCount / currentState.pagRate)}
        activePage={currentState.page}
        onSelect={page =>
          updatePageNum({
            ...currentState,
            page: page,
          })
        }
      />
    </div>
  )
}

export default NotebookPagintaion
